/**
 * @architecture-header 1
 * @layer route
 * @domain workspace-shell
 * @responsibility Host the workspace settings tabs, starting with the AI assistant personas.
 * @state-owner local tab state; each tab owns its own data
 * @allowed-imports React; shared components and hooks; module public APIs
 * @forbidden module internals; direct API client
 * @public-api account popover
 * @side-effects none of its own
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import { useState } from 'react';
import { AssistantSettingsPage } from '../../modules/assistants';
import { ModalDocument } from '../../shared/components/Modal';
import { useOverlay } from '../../shared/components/OverlayHost';
import { VSegment } from '../../shared/components/VTable';
import { TEACHER_NAME } from '../../shared/lib/demo-data';
import { useTranslator } from '../../shared/model/use-workspace';

type SettingsTab = 'ai' | 'acc';

export function SettingsDialog({ initialTab = 'ai' }: { initialTab?: SettingsTab }) {
  const t = useTranslator();
  const { closeModal } = useOverlay();
  const [tab, setTab] = useState<SettingsTab>(initialTab);

  return (
    <ModalDocument
      className="setdoc"
      footer={
        <>
          <div className="sp" />
          <button className="bt" type="button" onClick={closeModal}>
            {t('關閉')}
          </button>
        </>
      }
      maxWidth={1000}
      subtitle={`${TEACHER_NAME} · ${t('老師')}`}
      title={t('設定')}
    >
      <div className="vtbar" style={{ padding: 0, marginBottom: 12 }}>
        <VSegment
          onChange={(value) => setTab(value as SettingsTab)}
          options={[
            { value: 'ai', label: t('AI 助教') },
            { value: 'acc', label: t('帳號') },
          ]}
          value={tab}
        />
      </div>
      {tab === 'ai' ? (
        <AssistantSettingsPage />
      ) : (
        <div className="vguide">
          <b>{t('帳號資料')}</b>
          <span>{t('這一區還沒接上，先從 AI 助教開始設定。')}</span>
        </div>
      )}
    </ModalDocument>
  );
}
